import React from 'react'
import main from "./assets/main.png"
function LeftSide({discounts, message}) {
  return (
    <div className='left'>
      <img src={main} alt="" width="80%"/>
      {!message && discounts.length < 1 && <p>Pay with your debit or credit cards and get a discount off your total amount.</p>}
      {discounts && discounts.length > 0 && 
        <>
          <p className='main'>Get discount!</p>
          {message.includes("\r\n") ?
            <ul>
              {message.split("\r\n").map((ele, index) => (
                <li key={index}>{ele}</li>
              ))}
            </ul>
          :
            <p>{message}</p> 
          }
          <div className="imgs-container">
            { discounts.length > 1 ? discounts.map((discount) => (
              <div className='single-discount'>
                {discount.fee_type === "Fixed" ?
                  <p className='discount-amount'><span>{discount.fixed_portion}</span> off</p>
                  :
                  <p className='discount-amount'><span>{discount.percent_portion}%</span> off</p>
                }
                <img src={discount.logo} alt="" width="55px" />
              </div>
              ))
            : 
              <div className='single-discount'>
                {discounts[0].logo && <img src={discounts[0].logo} alt="" width="55px" />}
              </div>
            }
          </div>
        </>
      }
    </div>
  )
}

export default LeftSide